import moment from "moment";
const propagateChange = (val, type, setError, parseAndValidate, dispatch) => {
    try {
        //Parse with JSON.parse or dateParse
        const payload = parseAndValidate(val);
        setError(false);
        dispatch({ type, payload });
    }
    catch (e) {
        setError(true);
    }
};
const dateParse = (dateStr) => {
    const date = moment(dateStr);
    if (date.valueOf())
        return date;
    else
        throw new Error("Parsing error");
};
export const useDebugModule = () => {
    return { propagateChange, dateParse };
};
